import moment from 'moment'
import { STATUS_IDS } from '@/services/statuses'

export const ORDER_PHASE_CLOSE = 15

export const getDictionary = () => {
  return window.app
}

export const getDefaultOrderPhaseID = () => {
  return 29
}

export const getDefaultRFQID = () => {
  return moment().format('YYYY-MM-DD HH:mm:ss')
}
export const getDefaultPO = () => {
  return moment().format('YYMMDD') + 'x.'
}
export const getDefaultBaxPO = () => {
  return 'XXX' + moment().format('YYMMDD') + 'x.'
}

export const getCurrentEmployee = () => {
  return window.app.$store.getters.get('currentEmployee') || {}
}

export const vatsWithDisabled = (list) => {
  const CHECK = 'xxx'
  return list.map((item) => {
    let value = item.country.toLowerCase()
    if (value.startsWith(CHECK)) {
      return {
        ...item,
        disabled: true
      }
    } else {
      return item
    }
  })
}
export const vatsDataSourceConverter = (dataSource) => {
  const { records } = dataSource
  const withDisable = vatsWithDisabled(records)
  const map = withDisable.reduce((result, item) => {
    result['id'] = item
    return result
  }, {})

  return {
    ...dataSource,
    records: withDisable,
    map
  }
}
export const scoreDataSourceConverter = (dataSource, scoreIndex = 3) => {
  const { records } = dataSource
  const filterByScoreIndex = records.filter((item) => scoreIndex === item.scoreIndex)
  const map = filterByScoreIndex.reduce((result, item) => {
    result['id'] = item
    return result
  }, {})

  return {
    ...dataSource,
    records: filterByScoreIndex,
    map
  }
}

// TODO need double check
export const handlePasteInput = (e) => {
  let value = e.clipboardData.getData('text/plain')
  value = value.trim()
  e.preventDefault()
  requestAnimationFrame(() => {
    e.target.value = value
    const event = new Event('input', {
      bubbles: true,
      cancelable: true
    })

    e.target.dispatchEvent(event)
  })
}

export const filterStartsWith = (column, data) => {
  const { originField } = column
  const { search } = data
  return search
    ? `${originField}.StartsWith("${search}")`
    : ''
}

export const addDays = (date = new Date(), days = 28) => {
  const res = moment(date).add(days, 'days');

  [6, 0].forEach((holidayIndex) => {
    const day = res.day()
    if (day === holidayIndex) {
      res.add(1, 'days')
    }
  })
  return res.format()
}

export const stringToDate = (date) => {
  if (date instanceof Date) {
    return date
  } else if (!date) {
    return 0
  } else {
    return Date.parse(date)
  }
}
export const getUnavailableStockStatusID = () => {
  return STATUS_IDS.sold
}
export const isStockStatusAvailable = (statusID) => {
  return statusID !== getUnavailableStockStatusID()
}
export const stockStatusFilter = (data) => {
  return isStockStatusAvailable(data.value)
    ? `statusID!=${getUnavailableStockStatusID()}`
    : `statusID==${getUnavailableStockStatusID()}`
}

export const createDescription = ({ type, labelSelect, value, label }) => {
  const fieldLabel = window.app.L10n(label)
  const employee = getCurrentEmployee()
  const { name } = employee

  let description = ''
  switch (type) {
    case 'date':
    case 'checkbox':
      description = `${name} ${value ? 'checked' : 'unchecked'} the "${fieldLabel}"`
      break
    case 'select':
      const actionName = value
        ? `select "${labelSelect}" for`
        : 'clear'
      description = `${name} ${actionName} the "${fieldLabel}"`
      break
    default:
      description = `${name} change the "${fieldLabel}" to "${value}"`
  }

  return description
}

export const customerPoFollowUpOrderMap = {
  1: { field: 'id', order: 'desc' },
  2: { field: 'id', order: 'asc' },
  3: { field: 'reminderDate', order: 'desc' },
  4: { field: 'reminderDate', order: 'asc' },
  5: { field: 'dateInPhase', order: 'desc' },
  6: { field: 'dateInPhase', order: 'asc' },
  7: { field: 'rfq3.coreDueDate', order: 'desc' },
  8: { field: 'rfq3.coreDueDate', order: 'asc' }
}
export const poOpenOrderMap = {
  1: { field: 'id', order: 'desc' },
  2: { field: 'id', order: 'asc' },
  3: { field: 'reminderDate', order: 'desc' },
  4: { field: 'reminderDate', order: 'asc' },
  5: { field: 'phaseDate', order: 'desc' },
  6: { field: 'phaseDate', order: 'asc' }
}
export const customerPoFollowUpOrder = (index) => {
  return customerPoFollowUpOrderMap[index]
}
export const poOpenOrder = (index) => {
  return poOpenOrderMap[index]
}
export const SECOND_EMAIL_REPLY_TO = 'support@bel-airexpress.com'
